import { memo, useRef, useEffect, useCallback } from 'react';
import { isToday, isSameDay, isSameMonth } from 'date-fns';
import { DayContainer, DayButton } from '../../styled.js';
import { useCalendar } from '../../Context.js';
import { isDateDisabled } from '../../utils/index.js';
import { jsx } from 'react/jsx-runtime';

var Day = /*#__PURE__*/memo(function (props) {
  var date = props.date;
  var _useCalendar = useCalendar(),
    value = _useCalendar.value,
    onChange = _useCalendar.onChange,
    focusedDate = _useCalendar.focusedDate,
    setFocusedDate = _useCalendar.setFocusedDate,
    timeZone = _useCalendar.timeZone,
    locale = _useCalendar.locale,
    min = _useCalendar.min,
    max = _useCalendar.max;
  var isToday$1 = isToday(date);
  var isSelected = isSameDay(value, date);
  var shouldFocus = isSameDay(date, focusedDate);
  var elementRef = useRef(null);
  var disabled = isDateDisabled({
    date: date,
    min: min,
    max: max
  });
  var title = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    timeZone: timeZone
  }).format(date);
  useEffect(function () {
    if (elementRef.current && shouldFocus) {
      elementRef.current.focus();
    }
  }, [elementRef, shouldFocus]);
  var ariaFormat = new window.Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: timeZone
  });
  var handleClick = useCallback(function () {
    if (onChange) {
      onChange(date);
    }
  }, [onChange, date]);
  return /*#__PURE__*/jsx(DayContainer, {
    children: /*#__PURE__*/jsx(DayButton, {
      $isSelected: isSelected,
      onClick: handleClick
      // eslint-disable-next-line react-hooks/exhaustive-deps
      ,
      onFocus: useCallback(function () {
        return setFocusedDate(date);
      }, [date]),
      disabled: disabled,
      ref: elementRef,
      tabIndex: isSameDay(value, date) ? 0 : -1,
      $isSameMonth: isSameMonth(date, focusedDate),
      "aria-label": ariaFormat.format(date),
      $isToday: isToday$1,
      children: title
    })
  });
});
Day.displayName = 'Day';
var Day$1 = Day;

export { Day$1 as default };
